import EmptyStatesPreview from '../content/EmptyStatesPreview'
import {
  Artwork,
  LinkButton
} from '@eggplant/pattern-library'
import { HiPlus } from 'react-icons/hi'
import {
  LinkToAddTestConfig,
  useConfigTypeTitle,
  useModule
} from '@eggplant/routing'
import { LinkToRunnerDoc } from '../links'
import { SpaceAccessControl } from '@eggplant/context'

const RunnerIntro = () => {
  const [isMonitorFlag] = useModule()
  const configTypeText = useConfigTypeTitle()
  const configTypeTitle = useConfigTypeTitle(true)

  const runnerTypeTitle = !isMonitorFlag
    ? 'Runner'
    : 'Monitor Runner'

  const description = `The ${runnerTypeTitle} is where you can schedule and run ${configTypeText} config and view the results of the runs.

Before you can use the ${runnerTypeTitle}, you must have at least one ${configTypeTitle} Config.

🤟 Let’s start by creating a new ${configTypeText} config!`

  const renderButton = () =>
    <SpaceAccessControl isHiddenIfDenied>
      <LinkButton
        title={`New ${configTypeTitle} Config`}
        variant='primary'
      >
        <LinkToAddTestConfig>
          <HiPlus
            aria-hidden
            size='19.2px'
          /> New {configTypeTitle} Config
        </LinkToAddTestConfig>
      </LinkButton>
    </SpaceAccessControl>

  return (
    <div className='grid h-full justify-center'>
      <div className='grid w-[36em]'>
        <EmptyStatesPreview
          action={renderButton()}
          description={description}
          icon={<Artwork.Path />}
          renderLink={<LinkToRunnerDoc />}
          title={runnerTypeTitle}
        />
      </div>
    </div>
  )
}

export default RunnerIntro
